import * as RA from "fp-ts/ReadonlyArray";
export class Exception extends Error {
    constructor(e) {
        super(e.message);
        this.context = e.context;
        this.kind = e.kind;
        this.message = e.message;
        this.type = e.type;
    }
}
export const exception = (kind) => (message, context) => new Exception({
    context: context ? [context] : [],
    kind,
    message,
    type: "Exception",
});
export const exceptionWithMultipleContext = (kind) => (message, context) => new Exception({
    context: RA.toArray(context),
    kind,
    message,
    type: "Exception",
});
export const exceptionMessageStack = (e) => [e.message].concat(RA.chain(exceptionMessageStack)(e.context));
export const exceptionMessagesStack = (e) => RA.chain(exceptionMessageStack)(e);

